import React from "react";
import { Quote } from "lucide-react";
import { TIDS } from "@/lib/testIds";

const testimonials = [
  {
    quote:
      "In four months we went from 12 new patients a month to 71. The team just runs. I don't touch marketing anymore.",
    name: "Dr. Anjali Rao",
    role: "Owner, Bright Smile Dental, Austin, TX",
    metric: "+491% new patients",
  },
  {
    quote:
      "I've hired three agencies in five years. Dental Leads Lab is the first one that reports on booked appointments, not clicks.",
    name: "Dr. Marcus Chen",
    role: "Cosmetic & Implant Dentistry, Toronto",
    metric: "$412K in implant revenue attributed",
  },
  {
    quote:
      "Our associate schedule was empty. Six weeks in it was fully booked, and we opened a second op.",
    name: "Dr. Priya Shah",
    role: "Orthodontist, Jersey City, NJ",
    metric: "2nd operatory funded from ads",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-6">
            <div className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-blue-400 mb-4">
              / 04 · In their words
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter font-medium text-white leading-[1.05]">
              Dentists who stopped worrying about the schedule.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              data-testid={TIDS.testimonialCard(i + 1)}
              className={`relative rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-8 md:p-10 hover:-translate-y-1 hover:border-white/25 transition-[transform,border-color] duration-300 flex flex-col ${
                i === 1 ? "md:translate-y-8 bg-blue-900/15 border-blue-500/25" : ""
              }`}
            >
              <Quote className="w-8 h-8 text-amber-400" />
              <blockquote className="mt-6 font-display text-lg md:text-xl text-white/90 leading-snug tracking-tight flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-amber-400/10 border border-amber-400/30 text-amber-300 px-3 py-1 self-start">
                <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em]">
                  {t.metric}
                </span>
              </div>
              <figcaption className="mt-6 pt-6 border-t border-white/10">
                <div className="font-display text-white text-base">{t.name}</div>
                <div className="text-xs text-white/50 mt-0.5">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
